export const loginUrl = '/api/v1/auth/signin';
export const authPreflightUrl = '/api/v1/auth/preflight';
export const forgotPasswordUrl = '/api/v1/auth/forgot-password';
export const confirmForgotPasswordUrl = '/api/v1/auth/forgot-password/confirm';
export const changePasswordUrl = '/api/v1/auth/password/new';
export const codeMFAUrl = '/api/v1/auth/2fa/mfa_code';
export const resendMFACodeUrl = '/api/v1/auth/2fa/mfa_code/resend';
